// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2S_Yw","info":"PatientInfo_info__26Djf"};